<div [class]="field.styleValue">
    <span class="text-value">
      {{ value$ | async }}
    </span>
</div>
